import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dataService } from '../services/dataService';
import { profileFetchSucceeded, setFetching } from '../pages/Pricing/pricingSlice';
import { setProfileData } from '../pages/account/profileSlice';
import { setName } from '../pages/account/nameSlice';
import { setFirstUser } from '../pages/auth/registrationSlice';

export function useProfileData() {
    const dispatch = useDispatch();
    const pricing = useSelector((state) => state.pricingSlice);

    // Keep latest pricing values in a ref so fetchProfile stays stable
    const pricingRef = useRef(pricing);
    pricingRef.current = pricing;

    const fetchProfile = useCallback(async ({ force = false } = {}) => {
        const { isFetching, lastFetchedAt } = pricingRef.current;
        if (isFetching) return;
        if (!force && lastFetchedAt) return;

        dispatch(setFetching(true));
        const email = localStorage.getItem('user');
        try {
            const response = await dataService.ViewProfile({ email });
            if (response.error === false) {
                const data = response.data.data.data;
                const resolvedPlan = data.plan_type === undefined
                    ? (data.free_user === true ? 'Free' : 'Pro')
                    : data.plan_type;

                dispatch(profileFetchSucceeded({
                    plan_type: resolvedPlan,
                    free_user: data.free_user,
                    email_address: data.email_address,
                }));
                dispatch(setProfileData(data));
                dispatch(setName(`${data.first_name} ${data.last_name}`));
                if (data.is_first_time_login !== undefined) {
                    dispatch(setFirstUser(data.is_first_time_login));
                }
            } else {
                dispatch(setFetching(false));
            }
        } catch {
            dispatch(setFetching(false));
        }
    }, [dispatch]); // stable — reads pricing via ref, not as a dep

    return { fetchProfile };
}
